import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import Swal from 'sweetalert2';
import { ConsumersService } from '../../consumers.service';

@Component({
  selector: 'app-consumer-logs',
  templateUrl: './consumer-logs.component.html',
  styleUrls: ['./consumer-logs.component.scss']
})
export class ConsumerLogsComponent extends FeaturesBaseComponent implements OnInit {
  rowSelection: string;
  searchValue; 
  showEditPromotion: boolean = false;
  gridApi: any;
  gridColumnApi: any;
  selectedRows: any;
  consumerLogsData: any = [];
  consumerLogsColumnDef: any = [];
  columnDefs: any;
  userId: any;
  constructor(private activeRoute: ActivatedRoute,private router: Router, private consumersService: ConsumersService) {
    super();
    this.userId =this.activeRoute.snapshot.params.userId;
    this.getConsumerLogsHistory();
  }
  getConsumerLogsHistory() {
    this.consumersService.consumerLogsHistory(this.userId).subscribe(res => {
      this.consumerLogsData = res['data']
      this.gridApi.refreshCells();

    })
  }

  ngOnInit(): void {
    super.ngOnInit();
    const self = this;
    this.consumerLogsColumnDef = [
      { field: 'logType', headerName: 'Log type' , width: 200  },
      { field: 'dateandtime', headerName: 'Date & Time', width: 250 , cellRenderer: (data) => { return moment(data.value).format('MM/DD/YYYY hh:mm:ss:a');}},
      { field: 'event', headerName: 'Event', width: 140 },
      { field: 'source', headerName: 'Source', width: 160 },
      { field: 'infoChangedFor', headerName: 'Info changed for', width: 290 },
      { field: 'changedBy', headerName: 'Changed by', width: 250},
      { field: 'device', headerName: 'Device', width: 150 },
      { field: 'fieldChanged', headerName: 'Field Changed', width: 260},
      { field: 'previousValue', headerName: 'Previous Value', width: 200},  
      { field: 'currentValue', headerName: 'Current Value', width: 160},
      { field: 'ipAddress', headerName: 'Ip', width: 160},  
      { field: 'location', headerName: 'Location', width: 160},  
    ]
  }
 
  ngOnDestroy() {
    super.ngOnDestroy();
  }
  
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


}